__turbopack_context__.v({
  "GC": "styles-module-scss-module__QKQKwq__GC",
  "SC": "styles-module-scss-module__QKQKwq__SC",
  "defaultColor": "styles-module-scss-module__QKQKwq__defaultColor",
  "icon": "styles-module-scss-module__QKQKwq__icon",
  "landscape": "styles-module-scss-module__QKQKwq__landscape",
  "root": "styles-module-scss-module__QKQKwq__root",
});
